import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './index.module.scss';
import { Mask, Toast } from 'antd-mobile';
import Library from 'library';
import Service from '../../nft-official/service';
const { JsBridge, Util } = Library;

const ReceiveModal = ({ onClose, callBack, prizeInfo }) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {

    }, []);

    const onDidFocus = () => {
        JsBridge.addListener().then(() => {
            
        });
    }

    const handleClick = async () => {
        if(callBack) {
            const result = await callBack()
            if(!result) {
                return Toast.show({
                    content: '领取奖励失败，请重新领取',
                    afterClose: onMask
                })
            }
            const prizeInfo = result.data || {}
            const param = Util.url.objectToQueryParams({
                idf: 'commonSub',
                activityCode: Service.activityCode,
                name: prizeInfo.prizeName,
                imgUrl: prizeInfo.imageUrl,
                req: prizeInfo.req,
            });
            JsBridge.push('CustomWeb', { uri: `${window.location.origin}/front/guapp/activityOrder?${param}` });
            onDidFocus();
        }

        onClose && onClose();
        setVisible(false);
    }

    const onMask = () => {
        onClose && onClose();
        setVisible(false);
    }


    return <Mask className={styles.guessing_rule_mask} visible={visible} onMaskClick={onMask}>
        <div className={styles.rules_modal_common}>
            <div className={styles.modal_container}>
                {/* <img src={require('images/mask-light-close.png')} alt="" className={styles.icon_close} onClick={onMask} /> */}
                <div className={styles.container}>
                    <div className={styles.modal_title}>{prizeInfo ? '领取成功！': '抱歉'}</div>
                    <div className={styles.modal_content}>
                    {
                        prizeInfo ?
                        `奖品将在活动结束后空投到您的账号
                        请在首页底部我的藏品中查看`
                        :
                        `抱歉，当前奖品已领完`
                    }
                    </div>
                    <div className={styles.rules_btn} onClick={onMask}>确定</div>
                </div>

            </div>
        </div>
    </Mask>
}

ReceiveModal.open = ({prizeInfo, callBack}) => {
    let div = null;
    if (!div) {
        div = document.createElement('div');
    }
    document.body.appendChild(div);
    const close = () => {
        div.remove();
    }
    ReactDOM.render(<ReceiveModal onClose={close} prizeInfo={prizeInfo} callBack={callBack}/>, div);
}

export default ReceiveModal;
